import React, {
    FunctionComponent,
  } from "react";
  import styles from "./NewComponents.module.css";
  import { connect, useDispatch } from "react-redux";
  import {themeColors} from "../../theme";
  type props = {
    title:string,
    onClick: any,
    style?: object,
  };
  
  const NewButton: FunctionComponent<props> = ({
    title,
    onClick,
    style
  }) => {
    return (
      <>
          <button
          className={styles.newButton}
          onClick={onClick}
          style={style}
        >
          {title}
        </button>
      </>
    );
  };
  
  const mapStateToProps = (state: any) => {
    return {
    };
  };
  
  export default connect(mapStateToProps)(NewButton);
  